export default __webpack_public_path__ + "static/media/bigStatusTrue.93378d23.svg";